import de from '@translations/de/useValidation.json';
import en from '@translations/en/useValidation.json';
import pl from '@translations/pl/useValidation.json';
import sl from '@translations/sl/useValidation.json';
import uk from '@translations/uk/useValidation.json';
import bg from '@translations/bg/useValidation.json';
import cz from '@translations/cz/useValidation.json';
import fr from '@translations/fr/useValidation.json';
import gr from '@translations/gr/useValidation.json';
import it from '@translations/it/useValidation.json';
import pr from '@translations/pr/useValidation.json';
import ru from '@translations/ru/useValidation.json';
import sk from '@translations/sk/useValidation.json';
import sp from '@translations/sp/useValidation.json';
import tr from '@translations/tr/useValidation.json';
import hu from '@translations/hu/useValidation.json';
import { ITranslations } from '@/types/common';
import { UseValidationTransFields } from './types';

export const useValidationTranslations: ITranslations<UseValidationTransFields> = {
  name: 'useValidation',
  de,
  en,
  pl,
  sl,
  uk,
  bg,
  cz,
  fr,
  gr,
  it,
  pr,
  ru,
  sk,
  sp,
  tr,
  hu,
};
